import React from 'react';

const CustomerKind = React.lazy(() => import('pages/CustomerKind/CustomerKind'));
const CustomerKindAdd = React.lazy(() => import('pages/CustomerKind/CustomerKindAdd'));
const CustomerKindEdit = React.lazy(() => import('pages/CustomerKind/CustomerKindEdit'));
const CustomerKindDetail = React.lazy(() => import('pages/CustomerKind/CustomerKindDetail'));

const customerKind = [
  {
    path: '/customer-kind',
    exact: true,
    name: 'Danh sách kiểu khách hàng',
    function: 'CRM_CUSTOMERKIND_VIEW',
    component: CustomerKind,
  },
  {
    path: '/customer-kind/add',
    exact: true,
    name: 'Thêm mới kiểu khách hàng',
    function: 'CRM_CUSTOMERKIND_ADD',
    component: CustomerKindAdd,
  },
  {
    path: '/customer-kind/detail/:id',
    exact: true,
    name: 'Chi tiết kiểu khách hàng',
    function: 'CRM_CUSTOMERKIND_VIEW',
    component: CustomerKindDetail,
  },
  {
    path: '/customer-kind/edit/:id',
    exact: true,
    name: 'Chỉnh sửa kiểu khách hàng',
    function: 'CRM_CUSTOMERKIND_EDIT',
    component: CustomerKindEdit,
  },
];

export default customerKind;
